export * from './catalog-dashboard';
export * from './list-main';
export * from './details-main';

import { CatalogDashboardComponent } from './catalog-dashboard';
import { ListMainComponent } from './list-main';
import { DetailPages } from './details-main';


export const CatalogPages = [
    CatalogDashboardComponent,
    ListMainComponent,
    ...DetailPages
]